import { signal } from '@angular/core';
import { MaritalStatusEnum } from '@partners/constants';
import { TCatalogOption } from '../model';

export const maritalStatusCatalog$$ = signal<TCatalogOption[]>([
  { key: 'כן', value: MaritalStatusEnum.married },
  { key: 'לא', value: MaritalStatusEnum.single }
]);
